import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { InsuranceOwnerFormValues } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/interfaces";
import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";
import { MopedCoverage } from "Store/interfaces/products/coverage";
import { TfaAmount } from "../vehicleInterfaces";

export interface MopedProductIntroFormValues {
  registrationYear?: string;
  brand?: string;
  model?: string;
}

export interface MopedProductDetailsFormValues
  extends InsuranceOwnerFormValues,
    InjuriesFormValues {}

export interface MopedProductPriceFormValues extends TfaAmount {
  coverage: MopedCoverage;
}

export interface MopedPriceRequestInfo extends BaseProduct {
  year: number;
  brand: string;
  model: string;

  insuranceHolderIsMopedOwner: boolean;
  mopedOwnerAge: string | null;

  injuries: number;
  injuryYear?: number;

  dateOfBirth?: string;
}

export enum MopedInsuranceType {
  MOPED_DRIVER_AND_PASSENGER_ACCIDENT = "mopedAnsvar",
  MOPED_REDUCED_OWN_DAMAGE = "mopedDelkasko",
  MOPED_FULL_OWN_DAMAGE = "mopedKasko",
}

type MopedTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productDetails: {
    heading: TranslatedText;
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: {
      title: TranslatedText;
      description: TranslatedText;
    };
  };
};

type MopedFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint?: TranslatedText;
    placeholder?: TranslatedText;
    error: Record<string, TranslatedText>;
  };
};
export interface MopedTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: MopedFormTexts };
  tile: MopedTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<MopedCoverage, TranslatedText>;
  };
}
